import { createSelector } from '@ngrx/store';
import { PlayerStatus } from '../player.model';
import { PlayerState } from './player.reducer';

export const getPlayerState = (state: PlayerState) => (state as any).player as PlayerState;

export const getPlayRequestUrl = createSelector(
  getPlayerState,
  (state: PlayerState) => {
    if (state.status === PlayerStatus.PlayRequest) {
      return state;
    }
    return null;
  }
);

export const getStopRequest = createSelector(
  getPlayerState,
  (state: PlayerState) => {
    if (state.status === PlayerStatus.StopRequest) {
      return true;
    }
    return false;
  }
);

export const getActiveStates = createSelector(
  getPlayerState,
  (state: PlayerState) => {
    if (state.status !== PlayerStatus.PlayRequest &&
      state.status !== PlayerStatus.StopRequest) {
      return state;
    }
    return null;
  }
);
